import React, { createContext, useContext, useState } from "react";

import { NO_APP } from "@/common/constants";

type SidebarContextValue = {
  selectedApp: string;
  setSelectedApp: (app: string) => void;
  collapsed: boolean;
  setCollapsed: (c: boolean) => void;
};

const SidebarContext = createContext<SidebarContextValue>({
  selectedApp: NO_APP,
  setSelectedApp: () => {},
  collapsed: false,
  setCollapsed: () => {},
});

export const SidebarProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [selectedApp, setSelectedApp] = useState<string>(NO_APP);
  const [collapsed, setCollapsed] = useState<boolean>(false);

  return (
    <SidebarContext.Provider
      value={{ selectedApp, setSelectedApp, collapsed, setCollapsed }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
